import * as React from 'react';

import BaseSvg from '../../BaseSvg';
import { InjectedSvgProps } from '../../hocs';

export default class SidebarAlignLeftSvg extends React.PureComponent<InjectedSvgProps> {
    static defaultProps = {
        className: '',
    };

    render() {
        const { className, fillColor } = this.props;

        return (
            <BaseSvg viewBox="0 0 24 24" className={className}>
                <path fill={fillColor} d="M21,3V21H9.5V3H21m3-3H6.5V24H24V0Z" />
                <rect fill={fillColor} x="0.5" y="0.5" width="5.91" height="23" />
                <path fill={fillColor} d="M5.91,1V23H1V1H5.91m1-1H0V24H6.91V0Z" />
            </BaseSvg>
        );
    }
}
